import { Component, OnInit, HostListener, Inject, PLATFORM_ID, Input, OnDestroy, ViewChild, ElementRef, EventEmitter, Output, TransferState } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { MktDynamicOfferService } from 'src/app/core/services/mkt-dynamic-offer.service';
import { Subscription } from 'rxjs';
import { MktModalService } from 'src/app/core/services';
import { MktCommonModule } from 'src/app/common/mkt-common.module';

@Component({
  selector: "app-sticky-header",
  templateUrl: "./sticky-header.component.html",
  styleUrls: ["./sticky-header.component.scss"],
  standalone: true,
  imports: [MktCommonModule]
})
export class StickyHeaderComponent implements OnInit, OnDestroy {
  cardImageSize = "sm";
  @Input() cardDetails: any;
  @Input() hrefTarget: string = "_blank";
  @Input() acqLink: string = "";
  @Input() flowId: string = "";
  @Input() rightAligned = false;
  @Input() headerContent: any;
  @ViewChild('calltoApplySticky') calltoApplySticky: ElementRef;
  @Output() applyNowClicked = new EventEmitter<any>();
  @Output() callToApplyClicked = new EventEmitter<any>();

  cardApplyNowBtnLink: string;
  isStickyCardShow: true;
  private dynamicOfferSub: Subscription = new Subscription();

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(DOCUMENT) private _document,
    private mktDynamicOfferService: MktDynamicOfferService,
    public state: TransferState,
    private readonly modalService: MktModalService
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.addSticky();
      //get the dynamic url once the contet is load
      this.dynamicOfferSub = this.mktDynamicOfferService
        .getApplyNowContent()
        .subscribe(content => {
          this.cardApplyNowBtnLink = content.applyNowUrl;
        });
    }
  }

  ngOnDestroy() {
    this.dynamicOfferSub.unsubscribe();
  }

  @HostListener("window:scroll", [])
  private addSticky() {
    const timeoutInstance = setTimeout(() => {
      const mobileHeight = 0;
      const tabletHeight = 50;
      const desktopHeight = 50;
      const height =
        window.innerWidth > 992
          ? desktopHeight
          : window.innerWidth > 767
          ? tabletHeight
          : mobileHeight;
      const firstTr = <any>(
        this._document.querySelector(".customer-support")
      );
      const firstTrTop = firstTr ? firstTr.getBoundingClientRect().top : 1000;

      const secondTr = <any>(
        this._document.querySelector(".footer")
      );
      const scrollerTop = !!this.flowId
        ? window.scrollY
        : secondTr.getBoundingClientRect().top;
      const secondTrTop = secondTr
        ? window.innerWidth < 768
          ? scrollerTop - window.innerHeight
          : 1000
        : 1;
      const stickyRef = this._document.getElementsByClassName(
        "sticky-header"
      )[0];
      if (!stickyRef) return;
      // console.log(height, '>=', firstTrTop, '&&', secondTrTop, '> 0');
      if (height >= firstTrTop && secondTrTop > 0) {
        stickyRef.classList.add("sticky");
        this.setCardSize();
      } else {
        stickyRef.classList.remove("sticky");
        this.setCardSize();
      }

      clearTimeout(timeoutInstance);
    }, 0);
  }

  @HostListener("window:resize", [])
  setCardSize() {
    this.cardImageSize = window.innerWidth <= 1024 ? "tiny" : "sm";
    this.showStickyCard();
  }

  @HostListener("window:resize", [])
  showStickyCard() {
    this.isStickyCardShow =
      window.innerWidth <= 1024 ? this.cardDetails.showStickyCard : true;
  }
  openCallToApply(event: MouseEvent) {
    let callToApply = this.headerContent.callToApply;
    callToApply = {
      title: "",
      content: "",
      siteCatalyst: {},
      showCancelButton: false,
      cancelButtonText: callToApply.closeModalText,
      primaryButtonText: callToApply.closeModalText,
      url: "",
      useDefaults: false,
      children: callToApply.content
    };
    callToApply.genericTemplateContent = callToApply;
    const modalInstance = this.modalService.openModal(
      event,
      callToApply,
      false
    );

    if (true) {
      const handleOnClose = () => {
        (this.calltoApplySticky.nativeElement as HTMLAnchorElement).focus();
        modalCloseSub.unsubscribe();
        modalContinueSub.unsubscribe();
      };

      // Subscribe to modal close emitter
      const modalCloseSub =
        !!modalInstance &&
        modalInstance.onClose.subscribe(handleOnClose.bind(this));

      // Subscribe to modal continue emitter
      const modalContinueSub =
        !!modalInstance &&
        modalInstance.onContinue.subscribe(handleOnClose.bind(this));

      this.resizeModal();
    }

    if (modalInstance) { this.callToApplyClicked.emit('callToApplyClicked') }

    return false;
  }
  resizeModal() {
      const el = document.querySelector(".cds-modal-content") as HTMLElement;
      if (el) {
        let iWidth = "80vw";
        if (innerWidth <= 480) {
          iWidth = "100%";
        } else if (innerWidth > 1080) {
          iWidth = "50vw";
        }
        el.setAttribute("style", `width:${iWidth};margin: 10vw auto;`);
      }
  }

  applyNow(value){
    this.applyNowClicked.emit(value);
  }

}
